import { Toast as BaseToast } from '@base-ui/react/toast';
import { useCallback, useState } from 'react';
import type { JSX } from 'react';
import { ToastViewport } from './ToastViewport.js';

export type ToastProviderProps = BaseToast.Provider.Props & {
  readonly closeLabel?: string;
  readonly viewportLabel?: string;
  readonly position?: 'top-right' | 'bottom-right';
};

export function ToastProvider({
  children,
  closeLabel = 'Dismiss notification',
  viewportLabel = 'Notifications',
  position = 'bottom-right',
  ...props
}: ToastProviderProps): JSX.Element {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const containerRef = useCallback(
    (element: HTMLDivElement | null): void => setContainer(element),
    [],
  );
  return (
    <BaseToast.Provider {...props}>
      {children}
      <div ref={containerRef}>
        <BaseToast.Portal container={container}>
          <ToastViewport closeLabel={closeLabel} label={viewportLabel} position={position} />
        </BaseToast.Portal>
      </div>
    </BaseToast.Provider>
  );
}

export { useToastManager } from './useToastManager.js';
